import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=46ceb550&"
var script = {}
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=46ceb550&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports